import React from "react";
import NextFeatureLabel from "../NextFeatureLabel";
import CheckBoxMC from "../../../../components/CheckBoxMC";
import LoadingMC from "../../../../components/LoadingMC";
import PlatformAgentAccounts, { PLATFORM_GROUPS, flattenAccountsForLabel } from "./PlatformAgentAccounts";

const PlatformsOptions = ({
  selectedPlatforms,
  selectPlatforms,
  options,
  loadingPlatforms,
  retailerInfo,
  integrationsStatus,
  agentsLoading,
  loadOptions,
  pendingValues,
  onAgentSelect,
  isAgentDeleted
}) => {
  const borderClass = (key) => {
    if (selectedPlatforms.includes(key)) return 'tw-border-blue-300';
    return 'tw-border-gray-300';
  };

  const isIntegrated = (service) => {
    const key = `${service}_integrated`;
    return retailerInfo[key];
  }

  return (
    <div className="tw-flex tw-flex-col tw-gap-3 tw-mt-4">
      {options.map((option) => {
        const label = option.label.toLowerCase();
        const isActive = selectedPlatforms.includes(option.key);
        const accountsForGroup = !agentsLoading && PLATFORM_GROUPS[label]
          ? flattenAccountsForLabel(label, integrationsStatus, retailerInfo)
          : [];

        return (
          <React.Fragment key={`activation-option-${option.key}`}>
            {isIntegrated(label) && (
              <div
                className={`md:tw-w-full tw-flex tw-flex-row tw-items-center tw-rounded-xl tw-py-2 tw-mt-[4px] tw-border tw-px-[15px]
                  ${option.enabled ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed'}
                  ${borderClass(option.key)}`}
                onClick={() => option.enabled && selectPlatforms(option.key)}
                style={{ cursor: option.enabled ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed' }}
              >
                <div className="tw-flex tw-w-full tw-justify-between">
                  <div className="tw-flex">
                    <div className="tw-self-center">
                      <img src={`data:image/svg+xml;base64,${btoa(option.icon)}`} alt={`${option.label} icon`} className="tw-w-31" />
                    </div>
                    <div className="tw-self-center">
                      <span className="tw-inline-block tw-text-sm tw-ml-[2px]">
                        {option.label}
                      </span>
                    </div>
                  </div>
                  <div className="tw-flex tw-items-center">
                    {option.hasCheckbox ? (
                      <CheckBoxMC
                        checked={selectedPlatforms.includes(option.key)}
                        onChange={() => {}}
                        className="tw-w-5 tw-h-5"
                      />
                    ) : (
                      <NextFeatureLabel />
                    )}
                  </div>
                </div>
              </div>
            )}

            {isIntegrated(label) && isActive && accountsForGroup.length > 0 && (
              <PlatformAgentAccounts
                accounts={accountsForGroup}
                loadOptions={loadOptions}
                pendingValues={pendingValues}
                onSelect={onAgentSelect}
                isAgentDeleted={isAgentDeleted}
              />
            )}
          </React.Fragment>
        );
      })}
      {loadingPlatforms && (
        <LoadingMC loading={loadingPlatforms} />
      )}
    </div>
  );
};

export default PlatformsOptions;
